<template>
    <section
        v-if="included.length || excluded.length"
        class="package-checklist"
    >
        <h2 class="k-heading-3">
            What's included
        </h2>

        <div class="package-checklist__columns">
            <KCard
                v-if="included.length"
                variant="outline"
                padding="sm"
            >
                <h3 class="k-heading-5">
                    Included
                </h3>
                <KChecklist :items="included" />
            </KCard>

            <KCard
                v-if="excluded.length"
                variant="outline"
                padding="sm"
            >
                <h3 class="k-heading-5">
                    Not included
                </h3>
                <KChecklist
                    :items="excluded"
                    variant="excluded"
                />
            </KCard>
        </div>
    </section>
</template>

<script setup>
import { KCard, KChecklist } from '@vemedia/karibu'

defineProps({
    included: {
        type: Array,
        default: () => [],
    },
    excluded: {
        type: Array,
        default: () => [],
    },
})
</script>

<style lang="scss" scoped>
@use '@vemedia/bcn-components/scss/responsive' as *;

.package-checklist {
    margin-top: var(--space-7);

    > h2 {
        margin-bottom: var(--space-4);
    }

    &__columns {
        display: grid;
        gap: var(--space-4);

        @include tablet {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    h3 {
        margin-bottom: var(--space-3);
    }
}
</style>
